import { updateUrl, toTitleCase } from "./utils.js";

export const fetchSection = async (url, selector, sectionName) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${sectionName}`);
    }
    const text = await response.text();
    const section = new DOMParser()
      .parseFromString(text, "text/html")
      .querySelector(selector);
    if (!section) {
      throw new Error(`${sectionName} not found in fetched content`);
    }
    return section;
  } catch (error) {
    throw new Error(`Error fetching ${sectionName}: ${error.message}`);
  }
};

export const renderSection = async (url, selector, sectionName) => {
  try {
    const section = await fetchSection(url, selector, sectionName);
    const node = document.querySelector(selector);
    if (node) {
      node.parentNode.replaceChild(section, node);
    } else {
      const errorMessage = `Updated section on variant change for ${sectionName} not found`;
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error(error.message);
  }
};

const trackProductChange = async (handle) => {
  const rushFeeData = document.getElementById("rush-fee-variant");
  const { rushVariantId, defaultRushVariantId } = rushFeeData?.dataset || {};
  const rushFeeVariantId =
    rushVariantId || window.productDualSaleRushFeeVariantID;
  const defaultRushFeeVariantId =
    defaultRushVariantId || window.defaultDualSaleRushFeeVariantID;

  try {
    await fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        window.productInventory = product.variants?.map((variant) => {
          return {
            size: variant?.option1,
            shipping_details: variant?.option3,
            inventory: variant?.inventory_quantity,
            inventory_policy: variant?.inventory_policy,
          };
        });
        window.dispatchEvent(
          new CustomEvent("productChange", { detail: product }),
        );
        if (rushFeeVariantId !== "") {
          window.productDualSaleRushFeeVariantID = rushFeeVariantId;
        } else {
          window.productDualSaleRushFeeVariantID = defaultRushFeeVariantId;
        }
      });
  } catch (error) {
    console.error("trackProductChange error:", error);
  }
};

class VariantColors extends HTMLElement {
  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.querySelectorAll("label").forEach((label) => {
      window?.features && window?.features["pdp_redirect-test_2025-04"]
        ? label.addEventListener("click", () => this.redirect(label))
        : label.addEventListener("click", () => this.render(label));
    });
  }

  updateTitleAndCrossSellBox() {
    const productSection = document.querySelector(".product-wrapper");
    const colorLegend = productSection.querySelector("#color-legend");
    const newColorLegend = document.querySelector("#color-legend");
    const fabricLegend = productSection.querySelector("#fabric-legend");
    const newFabricLegend = document.querySelector("#fabric-legend");

    if (fabricLegend && newFabricLegend) {
      this.updateTitle(
        colorLegend.textContent.trim(),
        newColorLegend.textContent.trim(),
        fabricLegend.textContent.trim(),
        newFabricLegend.textContent.trim(),
      );

      const crossSellBox = document.querySelector(".cross-sell-upsell-box");
      if (crossSellBox) {
        crossSellBox.dataset.title = `Swatch - ${newFabricLegend.textContent.trim()} in ${newColorLegend.textContent.trim()}`;
      }
    } else {
      this.updateTitle(
        colorLegend.textContent.trim(),
        newColorLegend.textContent.trim(),
      );
    }
  }

  redirect(label) {
    const { product } = label.dataset;
    trackProductChange(product);
    const urlParams = window.location.search;
    setTimeout(() => {
      sessionStorage.setItem("scrollDepth", window.scrollY);
    }, 50);
    const url = `${window.location.origin}/products/${product}${urlParams}`;
    window.location.replace(url);
  }

  async render(label) {
    const { product } = label.dataset;
    await Promise.all([
      renderSection(
        `/products/${product}/?section_id=${this.dataset.sectionId}`,
        ".product-wrapper",
        "Product Wrapper Section",
      ),
      renderSection(
        `/products/${product}/?section_id=product--fabric-101-modal`,
        "fabric-modal",
        "Fabric 101 Modal",
      ),
      renderSection(
        `/products/${product}/?section_id=ss-ymal-carousel`,
        ".ss-ymal-carousel",
        "You Might Also Like Section",
      ),
      renderSection(
        `/products/${product}/?section_id=product--see-it-in-the-wild`,
        "#see-it-in-the-wild",
        "See It In The Wild Section",
      ),
      renderSection(
        `/products/${product}/?section_id=product--back-in-stock`,
        "#bis-input-container",
        "Back In Stock Section",
      ),
      renderSection(
        `/products/${product}/?section_id=product--reviews`,
        ".reviews-wrapper",
        "Reviews Section",
      ),
    ]);
    this.updateTitleAndCrossSellBox();
    initProduct();
    updateUrl("products", label.dataset.product);
    trackProductChange(product);
    this.updateTitleAndCrossSellBox();
  }

  updateTitle(previousColor, newColor, previousFabric, newFabric) {
    let newTitle = document.title.replace(
      toTitleCase(previousColor),
      toTitleCase(newColor),
    );

    if (previousFabric && newFabric) {
      newTitle = newTitle.replace(
        toTitleCase(previousFabric),
        toTitleCase(newFabric),
      );
    }

    document.title = newTitle;
  }
}

export default VariantColors;
